"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignmentClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const user_assignment_serializer_1 = require("../serializers/user-assignment.serializer");
const assignment_progress_serializer_1 = require("../serializers/assignment-progress.serializer");
const student_helper_1 = require("../helpers/student.helper");
const helpers_1 = require("../../helpers");
const get_1 = __importDefault(require("lodash/get"));
class UserAssignmentClient {
    constructor(client, serializer, assignmentProgressSerializer) {
        this.client = client;
        this.serializer = serializer;
        this.assignmentProgressSerializer = assignmentProgressSerializer;
        this.studentHelper = new student_helper_1.StudentHelper(UserAssignmentClient.acmaSDKOptions, UserAssignmentClient.acmaSDKRetryOptions);
    }
    static newInstance(options, retryOptions) {
        UserAssignmentClient.acmaSDKOptions = {
            ...options,
            baseURL: (0, helpers_1.removeAssignmentsPath)((0, get_1.default)(options, 'baseURL', undefined)),
        };
        UserAssignmentClient.acmaSDKRetryOptions = retryOptions;
        return new UserAssignmentClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new user_assignment_serializer_1.UserAssignmentSerializer(), new assignment_progress_serializer_1.AssignmentProgressSerializer());
    }
    async findOne(id, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments/${id}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async findByAssignment(assignmentId, filters, pageableOptions, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.findByAssignment`, {
            headers,
            params: {
                assignmentId,
                ...filters,
                ...pageableOptions,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async findByAssignee(filters, pageableOptions, headers) {
        if (filters.dueDate) {
            filters.dueDate = filters.dueDate.filter(Boolean).map((date) => date);
        }
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.findByAssignee`, {
            headers,
            params: {
                ...filters,
                ...pageableOptions,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async findByAssignmentAndAssignee(id, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.findByAssignmentAndAssignee/${id}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async start(userAssignmentId, assignmentId, headers) {
        const response = await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignments.start`, {}, {
            headers,
            params: {
                userAssignmentId,
                assignmentId,
            },
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async submit(userAssignmentId, assignmentId, headers) {
        const response = await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignments.submit`, {}, {
            headers,
            params: {
                userAssignmentId,
                assignmentId,
            },
        });
        const { data } = response.body;
        return this.serializer.serializeOne(data);
    }
    async findWithEvidencesByAssignment(assignmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.findWithEvidencesByAssignment/${assignmentId}`, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serializeUserAssignmentIds(data);
    }
    async score(scoreEntity, headers) {
        await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignments.score`, scoreEntity, {
            headers,
        });
    }
    async findStatusTotalsByAssignment(assignmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.findStatusTotalsByAssignment?assignmentId=${assignmentId}`, {
            headers,
        });
        return this.assignmentProgressSerializer.serialize(response.body);
    }
    async scoresToPublish(assignmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignments.scoresToPublish?assignmentId=${assignmentId}`, {
            headers,
        });
        return this.serializer.serialize(response.body);
    }
    async releaseScores(assignmentId, headers) {
        const response = await this.client.post(`${sdk_constants_1.API_PREFIX}/userAssignments.releaseScores?assignmentId=${assignmentId}`, {}, {
            headers,
        });
        return this.serializer.serialize(response.body);
    }
    async reopen(userAssignmentPayload, headers) {
        const assigneeIds = await this.studentHelper.transformToStudentIds(userAssignmentPayload.assigneeIds);
        const response = await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignments.reopen`, { ...userAssignmentPayload, assigneeIds }, {
            headers,
        });
        const { data } = response.body;
        return this.serializer.serialize(data);
    }
}
exports.UserAssignmentClient = UserAssignmentClient;
//# sourceMappingURL=user-assignment.client.js.map